import { targetConfig } from '@smartproxy/sp-utils';
import { motion } from 'framer-motion';

import { NewToggle } from '@/components/atoms/toggle/NewToggle';

import {
  responseFormatMap,
  responseFormatViews,
} from '../constants/response-formats';
import { useScraper } from '../state/context';

type ResponseFormatToggleProps = {
  selectedIndex: number;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;
};

export const ResponseFormatToggle = ({
  selectedIndex,
  setSelectedIndex,
}: ResponseFormatToggleProps) => {
  const { target } = useScraper();

  const responseFormat = targetConfig[target.name].format;
  const formatOptions = responseFormatViews.map(
    (view) => responseFormatMap[responseFormat][view]
  );

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
    >
      <NewToggle
        options={formatOptions}
        size='s'
        selectedIndex={selectedIndex}
        onValueChange={(i) => setSelectedIndex(i)}
        responsive={false}
        themeSwitchMode='normal'
      />
    </motion.div>
  );
};
